import { useMemo } from "react"


const useGroupsTableColumns = () => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: "קבוצה",
            },
        ], []
    )

    return columns
}

export default useGroupsTableColumns